"use client";
/* Core */
import { createSlice } from "@reduxjs/toolkit";
import {
  checkBitanicaLinkApi,
  fetchUserIp,
  generateTelLoginQrApi,
  userSession,
  getUserProfile,
  telegramBotAutoLogin,
  telegramLogin,
  telegramWebLogin,
  updateProfile,
  userSessionLogout,
  getWelcomeBonus,
  checkPromotionBonus,
  loginWithEmail,
  signUpWithEmail,
  verifyOTP,
} from "./actions";

/* Instruments */
// import { login } from "./actions";

const initialState = {
  user: null,
  loading: false,
  register: null,
  requestOTPLoading: false,
  updateLoader: false,
  logoutLoading: false,
  loadingBitanicLink: false,
  isBitanicaLinked: false,
  generateQrLoading: false,
  telMobLoading: false,
  qrLoginLoader: false,
  profileLoading: false,
  userIp: null,
  promotionBonusLoading: false,
  promotionBonus: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setUserDetails(state, action) {
      const { user } = action.payload;
      state.user = user;
    },
    clearUserDetails(state) {
      state.user = null;
    },
    setLoginBotQrLoader(state, action) {
      const { type } = action.payload;
      if (type === "qrLogin") {
        state.qrLoginLoader = true;
      } else {
        state.loading = true;
      }
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder

      .addCase(telegramLogin.pending, (state, action) => {
        // state.loading = true;
        state.telMobLoading = true;
      })
      .addCase(telegramLogin.fulfilled, (state, action) => {
        state.user = action.payload.data;
        // state.loading = false;
        state.isBitanicaLinked = action.payload?.data?.linkedWithBitanica;
        state.telMobLoading = false;
      })
      .addCase(telegramLogin.rejected, (state, action) => {
        state.user = null;
        // state.loading = false;
        state.telMobLoading = false;
      })
      .addCase(userSession.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(userSession.fulfilled, (state, action) => {
        state.user = action.payload.data;
        state.isBitanicaLinked = action.payload?.data?.linkedWithBitanica;
        state.loading = false;
      })
      .addCase(userSession.rejected, (state, action) => {
        state.user = null;
        state.loading = false;
      })
      .addCase(getUserProfile.pending, (state, action) => {
        state.profileLoading = true;
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.user = action.payload.data;
        state.profileLoading = false;
        state.isBitanicaLinked = action.payload?.data?.linkedWithBitanica;
      })
      .addCase(getUserProfile.rejected, (state, action) => {
        state.profileLoading = false;
      })
      .addCase(updateProfile.pending, (state, action) => {
        // state.loading = true;
      })

      .addCase(getWelcomeBonus.pending, (state, action) => {
        state.welcomeBonusLoading = true;
      })
      .addCase(getWelcomeBonus.fulfilled, (state, action) => {
        state.welcomeBonus = action.payload;
        state.welcomeBonusLoading = false;
      })
      .addCase(getWelcomeBonus.rejected, (state, action) => {
        state.welcomeBonusLoading = false;
      })

      .addCase(checkPromotionBonus.pending, (state, action) => {
        state.promotionBonusLoading = true;
      })
      .addCase(checkPromotionBonus.fulfilled, (state, action) => {
        state.promotionBonus = action.payload?.data;
        state.promotionBonusLoading = false;
      })
      .addCase(checkPromotionBonus.rejected, (state, action) => {
        state.promotionBonusLoading = false;
      })

      .addCase(updateProfile.fulfilled, (state, action) => {
        state.user = action.payload.data;
        state.isBitanicaLinked = action.payload?.data?.linkedWithBitanica;
        // state.loading = false;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        // state.loading = false;
      })
      .addCase(userSessionLogout.pending, (state, action) => {
        state.logoutLoading = true;
      })
      .addCase(userSessionLogout.fulfilled, (state, action) => {
        state.logoutLoading = false;
        state.user = null;
      })
      .addCase(userSessionLogout.rejected, (state, action) => {
        state.logoutLoading = false;
      })
      .addCase(checkBitanicaLinkApi.pending, (state, action) => {
        state.loadingBitanicLink = true;
        state.isBitanicaLinked = false;
      })
      .addCase(checkBitanicaLinkApi.fulfilled, (state, action) => {
        state.loadingBitanicLink = false;
        state.isBitanicaLinked = action.payload?.data?.is_linked;
      })
      .addCase(checkBitanicaLinkApi.rejected, (state, action) => {
        state.loadingBitanicLink = false;
        state.isBitanicaLinked = false;
      })
      .addCase(telegramBotAutoLogin.pending, (state, action) => {
        // handle loading direct using reducer
      })
      .addCase(telegramBotAutoLogin.fulfilled, (state, action) => {
        state.user = action.payload.data;
        state.isBitanicaLinked = action.payload?.data?.linkedWithBitanica;
        state.loading = false;
        state.qrLoginLoader = false;
      })
      .addCase(telegramBotAutoLogin.rejected, (state, action) => {
        state.user = null;
        state.loading = false;
        state.qrLoginLoader = false;
      })

      .addCase(telegramWebLogin.pending, (state, action) => {
        // handle loading direct using reducer
      })
      .addCase(telegramWebLogin.fulfilled, (state, action) => {
        state.user = action.payload.data;
        state.isBitanicaLinked = action.payload?.data?.linkedWithBitanica;
        state.loading = false;
        state.qrLoginLoader = false;
      })
      .addCase(telegramWebLogin.rejected, (state, action) => {
        state.user = null;
        state.loading = false;
        state.qrLoginLoader = false;
      })
      .addCase(generateTelLoginQrApi.pending, (state, action) => {
        state.generateQrLoading = true;
      })
      .addCase(generateTelLoginQrApi.fulfilled, (state, action) => {
        state.generateQrLoading = false;
      })
      .addCase(generateTelLoginQrApi.rejected, (state, action) => {
        state.generateQrLoading = false;
      })
      .addCase(fetchUserIp.rejected, (state, action) => {
        state.userIp = null;
      })
      .addCase(fetchUserIp.pending, (state, action) => {
        state.userIp = null;
      })
      .addCase(fetchUserIp.fulfilled, (state, action) => {
        state.userIp = action.payload;
      })

      .addCase(signUpWithEmail.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(signUpWithEmail.fulfilled, (state, action) => {
        state.user = action.payload.data;
        state.loading = false;
      })
      .addCase(signUpWithEmail.rejected, (state, action) => {
        state.user = null;
        state.loading = false;
      })

      .addCase(loginWithEmail.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(loginWithEmail.fulfilled, (state, action) => {
        state.user = action.payload.data;
        state.loading = false;
        state.isBitanicaLinked = action.payload?.data?.linkedWithBitanica;
      })
      .addCase(loginWithEmail.rejected, (state, action) => {
        state.user = null;
        state.loading = false;
      })

      .addCase(verifyOTP.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(verifyOTP.fulfilled, (state, action) => {
        state.user = action.payload.data;
        state.loading = false;
        state.isBitanicaLinked = action.payload?.data?.linkedWithBitanica;
      })
      .addCase(verifyOTP.rejected, (state, action) => {
        state.user = null;
        state.loading = false;
      });
  },
});

export default authSlice.reducer;
